import { render } from "./Game.vue?vue&type=template&id=602b79ec&scoped=true"
import script from "./Game.vue?vue&type=script&lang=js"
export * from "./Game.vue?vue&type=script&lang=js"

import "./Game.vue?vue&type=style&index=0&id=602b79ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-602b79ec"]])

export default __exports__